export default __webpack_public_path__ + "static/cover-16-f1b8d5dec100d1ea9d6378102f2de59f.jpg";